import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Pagination, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	ApprovedSvg,
	EyeIcon,
	RejectedSvg,
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon,
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomUserTableProps } from './type';

type QualityCheckActionType = 'APPROVE' | 'REJECT';

const CustomTable: FC<CustomUserTableProps> = (props) => {
	const { dataSource, medicineQcCount, handleTableChange, onShowSizeChange, isLoading, search, totalRecords, performSearchHandler, performFilterHandler, filterValue, currentPage, pageSize, setSearch, allUsers, setSelectedUser, selectedUser, selectedDate, setSelectedDate, viewHandler, onQualityCheckAction } = props

	const groceriesPermissions = useSelector(
		(state: any) => state?.userProfile
	);

	const isApprovalPermission = checkPermission(groceriesPermissions?.data?.permissions, {
		permissionName: 'GroceryQualityCheck',
		permission: ['approval'],
	});

	const isViewPermission = checkPermission(groceriesPermissions?.data?.permissions, {
		permissionName: 'GroceryQualityCheck',
		permission: ['view', 'viewAll'],
	});


	const actionHandler = (medicineObject: any, type: QualityCheckActionType) => {
		onQualityCheckAction(medicineObject, type);
	}

	const viewDataHandler = (medicineObject: any) => {
		viewHandler(medicineObject);
	};

	return (
		<>
			<div className={`${styles['body']} user-table`} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'Quality Check List'}
					setSearch={setSearch}
					allUsers={allUsers}
					setSelectedUser={setSelectedUser}
					selectedUser={selectedUser}
					selectedDate={selectedDate}
					setSelectedDate={setSelectedDate}
					totalRecords={totalRecords}
					medicineQcCount={medicineQcCount}
					qcTitle='QC user count'
				/>

				<Table
					rowKey={(record: any) => record?.id}
					dataSource={dataSource}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={'Product Name'}
						dataIndex="productName"
						key="productName"
						className="user-column bg-white"
						width={'15%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>
					<Column
						title="Manufacturer Name"
						dataIndex="manufacturerName"
						key="manufacturerName"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>


					<Column
						title="Brand"
						dataIndex="brand"
						key="brand"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Mrp"
						dataIndex="mrp"
						key="mrp"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Marketed By"
						dataIndex="marketedBy"
						key="marketedBy"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Image"
						dataIndex="image"
						key="image"
						className="bg-white"
						width={'10%'}
						align="center"
						render={(_value: unknown, record: any) => {
							const hasPrimary =
								record?.productPrimaryImageUrl &&
								String(record.productPrimaryImageUrl).trim() !== '';
							const hasSecondary =
								Array.isArray(record?.productSecondaryImageUrl) &&
								record.productSecondaryImageUrl.length > 0;

							if (hasPrimary || hasSecondary) {
								return (
									<CheckCircleOutlined
										style={{
											fontSize: '20px',
											color: '#52c41a',
										}}
									/>
								);
							}
							return (
								<CloseCircleOutlined
									style={{
										fontSize: '20px',
										color: '#ff4d4f',
									}}
								/>
							);
						}}
					/>

					{(isViewPermission || isApprovalPermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{
											isViewPermission ? (
												<div
													className="cursor-pointer flex align-center justify-center  "
													onClick={() =>
														viewDataHandler(data)
													}
												>
													<EyeIcon />
												</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center  ">
													<EyeIcon />
												</div>
											)}

										{isApprovalPermission ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													actionHandler(data, 'APPROVE')
												}
											>
												<ApprovedSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">
												<ApprovedSvg />
											</div>
										)}

										{isApprovalPermission ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													actionHandler(data, 'REJECT')
												}
											>
												<RejectedSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">
												<RejectedSvg />
											</div>
										)}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};


export default CustomTable;

